import React from "react";
import { Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const CustomDataGrid = ({ rows, columns, onRowClick ,selectedRowId}) => {
  const paginationModel = { page: 0, pageSize: 5 };

  return (

    <Paper
      sx={{
        height: "auto", 
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10]}
        onRowClick={onRowClick}
        rowHeight={40}
        data-testid="data-grid"
        disableColumnMenu
        showToolbar
        getRowClassName = {(params) =>
          params.id === selectedRowId ? "selected-row" : ""
        }

        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
        
          "& .MuiDataGrid-row": {
            backgroundColor: "#f0f8ff",
            "&:hover": {
              backgroundColor: "#e0f2fe ",
            },
          },
          "& .selected-row": {
            backgroundColor: "#2f539b !important",
             color: "#fff",  
            
          },
        }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
          },
        }}
      />
    </Paper>
  
  );
};

export default CustomDataGrid;
